import { render, staticRenderFns } from "./CreateTeamChallenge.vue?vue&type=template&id=876f5542&scoped=true&"
import script from "./CreateTeamChallenge.vue?vue&type=script&lang=js&"
export * from "./CreateTeamChallenge.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeamChallenge.vue?vue&type=style&index=0&id=876f5542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876f5542",
  null
  
)

export default component.exports